export enum StatusQuest{
    COMPLETED = "COMPLETED",
    STARTED = "STARTED",
    NOT_STARTED = "NOT_STARTED"
}